import { css, makeStyles } from '@conexasaude/hero'

const useStyles = makeStyles({
  imageStyle: css`
    width: 100%;
  `,
})

export default useStyles
